<template>
  <div :id="`office-${office.shortName}`" class="office">
    <div class="office__details">
      <i class="office-icon icon-bankoffice-circled"></i>

      <div class="office-name">
        <h3>{{ office.name }}</h3>
        <template v-if="office.contact">
          <div class="office-address">
            <span class="street">{{ office.contact.streetAddress }}</span>
            <span class="post">{{ office.contact.postalCode }} {{ office.contact.postOffice }}</span>
          </div>
        </template>
      </div>

      <div class="office-contact">
        <div class="office-contacts-wrapper">
          <div>
            <a
              v-if="office.contact && office.contact.phone"
              :href="`tel:${office.contact.phone}`"
              class="contact telephone"
              tabindex="0"
            >
              <i class="icon-phone-circled"></i>
              <span>{{ office.contact.phone }}</span>
            </a>
            <RouterLink
              class="call-pricing-link basic-link"
              :to="`${staticPage.paths.pricing}#puheluhinnat`"
              tabindex="0"
            >
              Katso puheluhinnat
            </RouterLink>
          </div>
          <div>
            <span v-if="office.contact && office.contact.email" class="contact email">
              <i class="icon-mail-circled"></i>
              <span>{{ office.contact.email }}</span>
            </span>
          </div>
        </div>
      </div>

      <div v-if="office.availability" class="office-hours">
        <span>{{ office.availability }}</span>
      </div>

      <div class="office-actions">
        <form-button text="Ota yhteyttä" theme="primary" tabindex="0" @click="openAgencyForm()" />
      </div>
    </div>

    <div class="office__contacts">
      <persons :persons="getOfficeStaff" :office="office" />
    </div>
  </div>
  <dialogue :identifier="`office-agency-dialogue-${office.id}`">
    <template #dialogueContent>
      <agency-contact :office="office" />
    </template>
  </dialogue>
</template>

<script lang="ts">
import Persons from '@/app/components/persons/persons.vue';
import { staticPage } from '@/app/routes';
import { defineAsyncComponent, defineComponent } from 'vue';

export default defineComponent({
  name: 'Office',
  components: {
    FormButton: defineAsyncComponent(() => import('@/app/components/form-button/form-button.vue')),
    Persons,
    AgencyContact: defineAsyncComponent(() => import('@/app/components/agency-contact/agency-contact.vue')),
    Dialogue: defineAsyncComponent(() => import('@/app/components/dialogue/dialogue.vue')),
  },
  props: {
    agencyId: {
      type: Number,
      required: false,
    },
    office: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    staticPage,
  }),
  computed: {
    getOfficeStaff() {
      const { officeManager } = this.office;
      // Note: other employees also contains marketing
      // and sales staff. Not only agents.
      const otherEmployees = this.office.agents || this.office.employee;

      // Place office manager as a first employee if present.
      return [...(officeManager && !officeManager.hidden ? [officeManager] : []), ...otherEmployees];
    },
  },
  methods: {
    openAgencyForm() {
      if (this.agencyId) {
        this.$bus.$emit('openDialogue', `company-agency-dialogue`);
      } else {
        this.$bus.$emit('openDialogue', `office-agency-dialogue-${this.office.id}`);
      }
    },
  },
});
</script>
